export default "__VITE_ASSET__97c26562__"